/**
 * BISI Engineering Website - Navigation Configuration
 * 
 * Central place to manage all navigation links and routes.
 */

// =============================================================================
// MAIN NAVIGATION LINKS
// =============================================================================

export const NAV_LINKS = [
  { name: 'Home', path: '/' },
  { name: 'About', path: '/about' },
  { name: 'Services', path: '/services' },
  { name: 'Projects', path: '/projects' },
  { name: 'Team', path: '/team' },
  { name: 'Clients', path: '/clients' },
  { name: 'Gallery', path: '/gallery' },
];

// =============================================================================
// FOOTER NAVIGATION
// =============================================================================

export const FOOTER_LINKS = {
  navigation: NAV_LINKS,
  services: [
    { name: 'Erection & Installation', path: '/services#service-1' },
    { name: 'Boiler Systems', path: '/services#service-2' },
    { name: 'Maintenance & Overhauling', path: '/services#service-3' },
    { name: 'Pipeline Works', path: '/services#service-4' },
    { name: 'Commissioning', path: '/services#service-5' },
    { name: 'Revamping', path: '/services#service-6' },
  ],
  legal: [
    { name: 'Privacy Policy', path: '/privacy' },
  ],
};

// =============================================================================
// SOCIAL LINKS
// =============================================================================

export const SOCIAL_LINKS = [
  { name: 'LinkedIn', url: '#', icon: 'L' },
  { name: 'Twitter', url: '#', icon: 'T' },
  { name: 'Facebook', url: '#', icon: 'F' },
];
